import { Component, OnInit } from '@angular/core';
import { faBars, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from '../share/enums/storage.enum';
import { StorageService } from '../share/services/storage-service/storage.service';
import { AuthService } from '../home/auth/auth.service';

import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  constructor(
    private readonly storageService: StorageService,
    public readonly authService: AuthService,
    public readonly router: Router
  ) {}
  protected readonly faBars = faBars;
  user: any = {};
  selectedCompany: any;
  enrollmentType: any;
  isAdmin: boolean = false;

  ngOnInit() {
    this.getSelfDetails();
    this.selectedCompany = this.user.company;
  }

  getSelfDetails() {
    this.user = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (this.user.enrollmentType === 'Admin') {
      this.isAdmin = true;
    }
    //Here we need to check this.user.company & show the value in dropdown
  }

  onCompanyChange(event: any) {
    if (event?.target?.value) {
      this.user = this.storageService.getDataFromLocalStorage(
        StorageKeys.SELF_DETAILS
      );
      this.selectedCompany = event.target.value;
      this.user.company = this.selectedCompany;
      this.storageService.setDataToLocalStorage(
        StorageKeys.PRESENT_COMPANY,
        this.selectedCompany
      );
      this.storageService.setDataToLocalStorage(
        StorageKeys.SELF_DETAILS,
        this.user
      );
      this.reloadPage();
    }
  }

  reloadPage() {
    location.reload();
  }

  protected faSignOut = faSignOut;

  signOut() {
    this.storageService.clearLocalStorage();
    this.storageService.clearSessionStorage();
    this.router.navigate(['login']);
  }

  redirectToHome() {
    if (!this.isAdmin) {
      this.router.navigate(['/home']);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
